import { render, staticRenderFns } from "./PaintworkFormPage.vue?vue&type=template&id=a6d32502"
import script from "./PaintworkFormPage.vue?vue&type=script&lang=js"
export * from "./PaintworkFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports